import { render, staticRenderFns } from "./SFDASources.vue?vue&type=template&id=da50b0bc"
import script from "./SFDASources.vue?vue&type=script&lang=js"
export * from "./SFDASources.vue?vue&type=script&lang=js"
import style0 from "./SFDASources.vue?vue&type=style&index=0&id=da50b0bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports